import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/pixel';

// Base pixel fires the first PageView; this fires on SPA route changes.
export default function usePixelPageViews() {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) { first.current = false; return; }
    trackPageView();
  }, [pathname]);
}
